<template>
  <v-card
    v-if="!cookiesAccepted"
    class="cookies-modal"
    elevation="4"
  >
    <v-card-title class="pb-0">
      <strong>NoMoreHaters usa cookies</strong>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col class="pt-0">
          Usamos cookies analíticas, totalmente anónimas, para entender cómo se usa la web.
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <BaseButton @click="accept()">
            <strong>Vale</strong>
          </BaseButton>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>
.v-btn {
  text-transform: none;
}
.cookies-modal {
  /* background-image: url('../assets/img/cookies.png'); */
  background-size: contain;
  background-position: bottom right;
  position: fixed;
  bottom: 16px;
  right: 16px;
  max-width: 460px;
  width: calc(100% - 32px);
  z-index: 100;
}

.over {
  z-index: 2;
}

.bg-pic {
  bottom: 0;
  height: 100%;
  position: absolute;
  right: 0;
  width: 80%;
  z-index: 1;
}
</style>

<script>
export default {
  name: 'CookiesModal',
  data: () => ({
    cookiesAccepted: false,
  }),
  methods: {
    accept() {
      localStorage.setItem('nmh_cookies', new Date());
      this.cookiesAccepted = true;
    },
  },
  created() {
    const accepted = localStorage.getItem('nmh_cookies');
    if (accepted || process.env.VUE_APP_BUILD_TARGET === 'app') {
      this.cookiesAccepted = true;
    }
  },
};
</script>
